import { IonButton, IonRow } from "@ionic/react";
import React, { FC, useState } from "react";
import { CSVLink } from "react-csv";
import AIModal from "../elements/AIModal";
import { API_URL } from "../../actions/settings";
import LoadingSpinner from "./LoadingSpinner";

interface IProps {
    data: any,
    headers:any,
    separator?:string,
    filename:string,
    full_download_url?:string
};

async function downloadFullCSV(token:any,url:string='') {

    return fetch(`${API_URL}/${url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      }

    })
      .then(data => data.blob())
   }


const CSVDownloadButtonModal:FC<IProps> = (props) => {
    const [opened, setOpened] = useState(false)
    const [downloading,setDownloading] = useState(false)

    const handleDownload = async (e:any) => {        
      if(props.full_download_url){
        setDownloading(true)
        const token = localStorage.getItem('token') || ""
        const res = await downloadFullCSV(`Token ${token.slice(1,-1)}`,props.full_download_url)        
        if(res){
          const url = window.URL.createObjectURL(res);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${props.filename}`);
          document.body.appendChild(link);
          link.click()
          link.parentNode!.removeChild(link);
          setDownloading(false)
          setOpened(false)
        }

        }

    }


    return <div>
        <IonButton onClick={()=>setOpened(!opened)} size="small">Download CSV</IonButton>
        <AIModal style={{'--height':'350px'}} opened={opened} setOpened={setOpened} title={'Download CSV'}>
            <IonRow>
                <div style={{width:'100%'}}>
                    <div style={{textAlign:'center'}}>Select option for the Download</div>
                    <ul>
                        <li>Currently Shown Data</li>
                        <li>All Data</li>
                    </ul>
                </div>
            </IonRow>        
            <IonRow className="ion-justify-content-center">
                {downloading ? <div>
                        <LoadingSpinner/> 
                        <div> This may take a few minutes depending on the amount of data.</div>
                    </div>: <>
                <IonButton size='small' >
                    <CSVLink className='btn' 
                        style={{color:'white',textDecoration:'none'}} 
                        data={props.data || []} 
                        headers={props.headers}
                        separator={props.separator || ','} 
                        filename={props.filename}>
                        Download Current Data
                    </CSVLink>
                </IonButton>
                <IonButton size='small' onClick={handleDownload} >
                        Download ALL Data                    
                </IonButton>
                </>}
            </IonRow>
        </AIModal>
    </div>
};

export default CSVDownloadButtonModal;